
import MasterDataBaseView from "../../../components/intern/master-data/MasterDataBaseView";
import {connect} from "react-redux";
import {push} from "connected-react-router";

const map2state = (state) => ({
});
const map2dispatch = (dispatch) => {
	return {
		onBack: () => dispatch(push('/master-data'))
	};
};

export default connect(map2state, map2dispatch)(MasterDataBaseView);